import { gameState } from '../game.js';

export class GameStateManager {
    /**
     * ゲーム状態マネージャーのコンストラクタ
     * @param {Phaser.Scene} scene - Phaserのシーンオブジェクト
     */
    constructor(scene) {
        this.scene = scene;
        this.isGameOver = false;
        this.isGameStarted = false;
    }

    /**
     * ゲームの開始
     * @param {Function} onStartCallback - ゲーム開始時のコールバック
     */
    startGame(onStartCallback) {
        this.isGameStarted = true;
        
        if (onStartCallback) {
            onStartCallback();
        }
    }

    /**
     * ゲームオーバー処理
     * @param {ScoreManager} scoreManager - スコアマネージャーのインスタンス
     */
    gameOver(scoreManager) {
        // ゲームオーバーフラグを立てる
        this.isGameOver = true;
        
        // ハイスコアの更新
        scoreManager.updateHighScore();
        
        // グローバル変数の更新
        gameState.playState.score = scoreManager.getScore();
        gameState.highScore = scoreManager.getHighScore();
        // 評価カウントの更新
        gameState.playState.evaluationCounts = scoreManager.getEvaluationCounts();
        // ゲームオーバーフラグの更新
        gameState.playState.gameOver = true;
    }

    /**
     * ゲームが開始されているかどうか
     * @returns {boolean} ゲーム開始フラグ
     */
    isStarted() {
        return this.isGameStarted;
    }

    /**
     * ゲームオーバーかどうか
     * @returns {boolean} ゲームオーバーフラグ
     */
    isOver() {
        return this.isGameOver;
    }

    /**
     * リソースのクリーンアップとリセット
     */
    cleanup() {
        this.isGameOver = false;
        this.isGameStarted = false;
    }
}
